import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  FLAG_GETTING_PREVENTIVE_REPORT,
  CLEAR_PREVENTIVE_REPORT,
  GET_PREVENTIVE_REPORT,
} from '../types';
import { PREVENTIVE_MAINTENANCE_REPORT_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingPreventiveMaintenanceReport = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_PREVENTIVE_REPORT,
    payload: flag,
  });

const clearPreventiveMaintenanceReport = () => (dispatch) =>
  dispatch({
    type: CLEAR_PREVENTIVE_REPORT,
  });

const postPreventiveMaintenanceReport =
  async ({
    page,
    size,
    order,
    sort,
    registeredBusIdList,
    homeBaseLocationId,
    companyResourceIdList,
    companyAreaId,
    daily,
    dateTo,
    dateFrom,
    simulationDays,
    simulationKilometers,
    force,
    dispatchData = true,
    activityId,
  }) =>
  async (dispatch) => {
    try {
      const params = {
        page,
        size,
        order,
        sort,
      };
      const payload = {
        registeredBusIdList,
        homeBaseLocationId,
        companyResourceIdList,
        companyAreaId,
        daily,
        dateTo,
        simulationDays,
        simulationKilometers,
        dateFrom,
        force,
        activityId,
      };
      dispatch(flagGettingPreventiveMaintenanceReport(true));
      const url = `${PREVENTIVE_MAINTENANCE_REPORT_ENDPOINT}?${QueryString.stringify(
        params,
      )}`;
      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      if (dispatchData)
        dispatch({ type: GET_PREVENTIVE_REPORT, payload: response });
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
      return null;
    } finally {
      dispatch(flagGettingPreventiveMaintenanceReport(false));
    }
  };

const postDownloadPreventiveMaintenanceReportCsv =
  ({
    registeredBusIdList,
    homeBaseLocationId,
    companyResourceIdList,
    companyAreaId,
    daily,
    dateTo,
    dateFrom,
    simulationDays,
    simulationKilometers,
    force,
    activityId,
  }) =>
  async (dispatch) => {
    try {
      const payload = {
        registeredBusIdList,
        homeBaseLocationId,
        companyResourceIdList,
        companyAreaId,
        daily,
        dateTo,
        dateFrom,
        simulationDays,
        simulationKilometers,
        force,
        activityId,
      };
      dispatch(flagGettingPreventiveMaintenanceReport(true));
      const url = `${PREVENTIVE_MAINTENANCE_REPORT_ENDPOINT}?download=true`;

      const res = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        headers: {
          ...(DEFAULT_POST_CONFIG.headers || {}),
          Accept: 'text/csv',
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Error ${res.status}`);
      }

      const blob = await res.blob();

      const cd = res.headers.get('Content-Disposition') || '';
      const match = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(cd);
      let filename = decodeURIComponent(
        (match && (match[1] || match[2])) || 'Proyeccion de Activades.csv',
      );

      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const dateStr = `${yyyy}-${mm}-${dd}`;

      if (filename.toLowerCase().endsWith('.csv')) {
        filename = filename.replace(/\.csv$/i, `_${dateStr}.csv`);
      } else {
        filename = `${filename}_${dateStr}.csv`;
      }

      const urlBlob = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(urlBlob);

      return true;
    } catch (e) {
      toastr.error('Error', e.message || 'No se pudo descargar el CSV');
      return false;
    } finally {
      dispatch(flagGettingPreventiveMaintenanceReport(false));
    }
  };

export {
  clearPreventiveMaintenanceReport,
  postPreventiveMaintenanceReport,
  postDownloadPreventiveMaintenanceReportCsv,
};
